export { InvestmentBankingBondIssuancePage as default } from "@nvb/ui";
